import request from '#/utils/request';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';
import { coPath, toWire, withIdempotencyKey } from './shared';

/** GET `…/legacy-collection-reconciliations`：歷史 PAID 子單核對（UNKNOWN／PARTIAL／VERIFIED）。 */
export async function fetchLegacyReconciliations(id) {
  const { data: raw } = await request.get(coPath(id, '/legacy-collection-reconciliations'));
  return parseVer4DetailResponse(raw);
}

/**
 * POST `…/legacy-collection-reconciliations/evidence`：`salesOrderId`、`amount`、`actualReceivedAt`、
 * `evidenceReference`、選填 `proofFileId`、`expectedVersionNo`。
 */
export async function addLegacyReconciliationEvidence(id, payload, { idempotencyKey }) {
  const { data: raw } = await request.post(
    coPath(id, '/legacy-collection-reconciliations/evidence'),
    toWire(payload),
    withIdempotencyKey(idempotencyKey),
  );
  return parseVer4DetailResponse(raw);
}

/** POST `…/legacy-collection-reconciliations/{salesOrderId}/verify`：`{ expectedVersionNo, attestation }`。 */
export async function verifyLegacyReconciliation(id, salesOrderId, payload, { idempotencyKey }) {
  const { data: raw } = await request.post(
    coPath(id, `/legacy-collection-reconciliations/${salesOrderId}/verify`),
    toWire(payload),
    withIdempotencyKey(idempotencyKey),
  );
  return parseVer4DetailResponse(raw);
}
